import BathroomIcon from "@/modules/common/components/ui-kit/icons/bathroom-icon";
import BedroomIcon from "@/modules/common/components/ui-kit/icons/bedroom-icon";
import ExpandIcon from "@/modules/common/components/ui-kit/icons/expand-icon";
import { Property } from "@/modules/lead-page/new/components/recommendations/recommendations";
import { Stack, Typography, useTheme } from "@mui/material";

interface PropertyCardProps {
  property: Property;
}

const PropertyCard = ({ property }: PropertyCardProps) => {
  const theme = useTheme();

  const propertyInfo = [
    {
      icon: <ExpandIcon />,
      value: property.unitArea,
    },
    {
      icon: <BedroomIcon />,
      value: property.numberOfBedrooms,
    },
    {
      icon: <BathroomIcon />,
      value: property.numberOfBathrooms,
    },
  ];
  return (
    <Stack
      direction="column"
      padding={theme.nawy.spacing.md}
      gap={theme.nawy.spacing.md}
      bgcolor="#F9F9F9"
      borderRadius={theme.nawy.radius["2xl"]}
    >
      <Stack direction="column" gap={theme.nawy.spacing.xs}>
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.lg.semibold,
            color: theme.nawy.colors.semantic.text.primary,
          }}
        >
          {property.propertyType} in {property.compoundName}
        </Typography>

        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.sm.regular,
            color: theme.nawy.colors.semantic.text.secondary,
          }}
        >
          {property.areaName}
        </Typography>
      </Stack>

      <Stack direction="column" gap={theme.nawy.spacing.xxs}>
        {propertyInfo.map((info) => (
          <Stack direction="row" gap={theme.nawy.spacing.xs}>
            {info.icon}

            <Typography
              sx={{
                ...theme.nawy.typography.english.variants.body.md.regular,
                color: theme.nawy.colors.semantic.text.primary,
              }}
            >
              {info.value}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Typography
        sx={{
          ...theme.nawy.typography.english.variants.body.md.semibold,
          color: theme.nawy.colors.semantic.text.extension.positive,
        }}
      >
        40% cash discount
      </Typography>
    </Stack>
  );
};

export default PropertyCard;
